<template>
  <div class="collection-topbar-harvest-meth">
    <div
      v-if="!isLoading"
      class="collection-topbar-harvest-meth-button-wrapper"
    >
      <button
        class="collection-topbar-harvest-meth-button"
        :class="{ disabled: harvestDisabled }"
        @click="initHarvestMeth"
      >
        <span v-if="showTimer">{{ timerText }} till next Harvest</span>
        <span v-else>
          <span
            v-if="isHarvesting"
            class="collection-topbar-harvest-meth-button-loading"
          >
            <span>Harvesting...</span>
            <img
              class="loader"
              src="../../assets/img/spinner-clear.svg"
              width="20"
            >
          </span>
          <span v-else>
            <span>Harvest ALL METH</span>
            <span
              v-if="harvestableMeth"
              class="collection-topbar-harvest-meth-button-harvestable"
            >+{{ harvestableMeth }}</span>
            <IInfo
              v-tooltip.bottom="{ distance: 25, disabled: showTimer, content: 'Website activity is highest right after 11:59pm CST. <br> Harvest a bit later for quicker processing.', html: true }"
              width="10"
            />
          </span>
        </span>
      </button>
      <div class="collection-topbar-harvest-meth__info">
        From METH Machine & Teens to METH Bank
      </div>
    </div>
    <div class="collection-topbar-harvest-meth-texts">
      <div class="collection-topbar-harvest-meth-title">
        METH BANK
      </div>

      <div class="collection-topbar-harvest-meth-balance">
        {{ harvestedBalance }} METH
      </div>
    </div>
    <div
      v-if="!isLoading"
      class="collection-topbar-harvest-meth-button-wrapper"
    >
      <button
        class="collection-topbar-harvest-meth-button"
        :class="{ disabled: claimDisabled }"
        @click.prevent="claimTeenMeth"
      >
        <span v-if="showClaimTimer">{{ claimTimerText }} till next Claim</span>
        <span v-else>Claim Harvested METH</span>
      </button>
      <div class="collection-topbar-harvest-meth__info">
        From METH Bank to wallet
      </div>
    </div>
  </div>
</template>

<script>
import { useMethBankStore } from "@/store/meth-bank";
import { useWalletCollectionStore } from "@/store/wallet-collection";
import { computed, ref, toRef, watch } from "vue";
import { useTimer } from "vue-timer-hook";
import { useHarvestMeth } from "@/composables/useHarvestMeth";
import { claimMethBankMeth } from "@/functions/claimMethBankMeth";
import IInfo from "@/assets/img/info.svg?inline"
export default {
  components: {
    IInfo
  },
  setup() {
    const walletCollectionStore = useWalletCollectionStore()
    const methBankStore = useMethBankStore()
    const claimTeenMeth = async () => {
      await claimMethBankMeth()

    }
    const { isHarvesting, harvest: harvestMeth } = useHarvestMeth()
    const initHarvestMeth = async () => {
      if (harvestDisabled.value) return;
      await harvestMeth()

    }
    const isLoading = computed(() => {
      return walletCollectionStore.isLoading
    })
    const isHarvestedToday = computed(() => methBankStore.isHarvestedToday)
    const timer = useTimer(methBankStore.nextHarvestDate, true)
    const timerText = computed(() => {
      const { hours, seconds, minutes } = timer
      return `${hours.value < 10 ? "0" + hours.value : hours.value}:${minutes.value < 10 ? "0" + minutes.value : minutes.value}`;
    })
    const showTimer = computed(() => {
      return !timer.isExpired.value && isHarvestedToday.value
    })

    const harvestedBalance = computed(() => methBankStore.balance)
    const harvestableMeth = computed(() => {
      return methBankStore.harvestableMeth
    })
    const harvestDisabled = computed(() => {
      return (
        showTimer.value ||
        !harvestableMeth.value ||
        isHarvesting.value
      );
    })
    const claimTimer = useTimer(methBankStore.nextClaimDate, true)
    const showClaimTimer = computed(() => {
      return !claimTimer.isExpired.value && !methBankStore.canClaimNow
    })

    const claimDisabled = computed(() => {
      return methBankStore.balance <= 0 || showClaimTimer.value;
    })
    const claimTimerText = computed(() => {
      const { hours, seconds, minutes } = claimTimer
      return `${hours.value < 10 ? "0" + hours.value : hours.value}:${minutes.value < 10 ? "0" + minutes.value : minutes.value}`;
    })
    watch(toRef(methBankStore, 'nextHarvestDate'), () => {
      timer.restart(methBankStore.nextHarvestDate)
    })
    watch(toRef(methBankStore, 'nextClaimDate'), () => {
      claimTimer.restart(methBankStore.nextClaimDate)
    })

    return { isHarvesting, showClaimTimer, claimTimerText, initHarvestMeth, isLoading, isHarvestedToday, timerText, showTimer, claimDisabled, harvestedBalance, harvestDisabled, claimTeenMeth, harvestableMeth }
  },

};
</script>
